var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPassage = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 19H19V5C19 4.45 18.55 4 18 4H6C5.45 4 5 4.45 5 5V19H4C3.45 19 3 19.45 3 20C3 20.55 3.45 21 4 21H6.04C6.59 21 7.04 20.55 7.04 20V6H17V20C17 20.55 17.45 21 18 21H20C20.55 21 21 20.55 21 20C21 19.45 20.55 19 20 19Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPassage);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/passage.6c88aacbab04f58160b3c809aa981e02.svg";